/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */
import { RouteConfig } from 'vue-router';
import { AUTH_STATE } from '@/config';

export default [
  {
    name: 'experience',
    path: '/experience',
    meta: { tabbar: 'secret/user', auth: AUTH_STATE.LOGGED_IN },
    components: {
      static: () => import('@/views/common/static'),
      header: () => import('@/views/common/header'),
      main: () => import('@/views/common/main'),
      footer: () => import('@/views/common/footer'),
    },
    redirect: { name: 'experience_index' },
    children: [
      {
        name: 'experience_index',
        path: '',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '获取更多经验' },
        component: () => import('@/views/user/experience/experience.vue'),
      },
    ],
  },
] as RouteConfig[];
